import axiosClient from './axiosClient'

const logApi = {
  listAll: (params) => {
    const url = '/logSystem/getAll'
    return axiosClient.post(url, params)
  },
}

export default logApi
